/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Document } from '../models/Document';
import { Extension } from '../models/Extension';
import { IVisitable } from '../models/IVisitable';
import { ValidationProblem } from '../models/ValidationProblem';
import { Contact } from '../models/common/Contact';
import { ExternalDocumentation } from '../models/common/ExternalDocumentation';
import { IDefinition } from '../models/common/IDefinition';
import { Info } from '../models/common/Info';
import { License } from '../models/common/License';
import { Operation } from '../models/common/Operation';
import { Parameter } from '../models/common/Parameter';
import { Schema } from '../models/common/Schema';
import { SecurityRequirement } from '../models/common/SecurityRequirement';
import { SecurityScheme } from '../models/common/SecurityScheme';
import { Tag } from '../models/common/Tag';
import { IVisitor } from './IVisitor';

/**
 * Constructor.
 * @param {*[]} visitors
 * @class
 * @author eric.wittmann@gmail.com
 */
export class CompositeVisitor implements IVisitor {
    /*private*/ visitors : Array<IVisitor> = <any>([]);

    public constructor(visitors : Array<IVisitor>) {
        this.visitors = visitors;
    }

    /**
     * Adds a visitor.
     * @param {*} visitor
     */
    public addVisitor(visitor : IVisitor) {
        /* add */(this.visitors.push(visitor)>0);
    }

    /**
     * Adds multiple visitors.
     * @param {Bound[]} visitors
     */
    public addVisitors(visitors : Array<any>) {
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(this.visitors, visitors);
    }

    /**
     * Make the node accept all of the visitors.
     * @param {*} node
     */
    acceptAll(node : IVisitable) {
        this.visitors.forEach((visitor) => {
            node.accept(visitor);
        });
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitValidationProblem(io.apicurio.datamodels.core.models.ValidationProblem)
     * @param {ValidationProblem} problem
     */
    public visitValidationProblem(problem : ValidationProblem) {
        this.acceptAll(problem);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitDocument(io.apicurio.datamodels.core.models.Document)
     * @param {Document} node
     */
    public visitDocument(node : Document) {
        this.acceptAll(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitExtension(io.apicurio.datamodels.core.models.Extension)
     * @param {Extension} node
     */
    public visitExtension(node : Extension) {
        this.acceptAll(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitInfo(io.apicurio.datamodels.core.models.common.Info)
     * @param {Info} node
     */
    public visitInfo(node : Info) {
        this.acceptAll(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitContact(io.apicurio.datamodels.core.models.common.Contact)
     * @param {Contact} node
     */
    public visitContact(node : Contact) {
        this.acceptAll(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitLicense(io.apicurio.datamodels.core.models.common.License)
     * @param {License} node
     */
    public visitLicense(node : License) {
        this.acceptAll(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitTag(io.apicurio.datamodels.core.models.common.Tag)
     * @param {Tag} node
     */
    public visitTag(node : Tag) {
        this.acceptAll(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitSecurityRequirement(io.apicurio.datamodels.core.models.common.SecurityRequirement)
     * @param {SecurityRequirement} node
     */
    public visitSecurityRequirement(node : SecurityRequirement) {
        this.acceptAll(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitExternalDocumentation(io.apicurio.datamodels.core.models.common.ExternalDocumentation)
     * @param {ExternalDocumentation} node
     */
    public visitExternalDocumentation(node : ExternalDocumentation) {
        this.acceptAll(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitSchema(io.apicurio.datamodels.core.models.common.Schema)
     * @param {Schema} node
     */
    public visitSchema(node : Schema) {
        this.acceptAll(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitParameter(io.apicurio.datamodels.core.models.common.Parameter)
     * @param {Parameter} node
     */
    public visitParameter(node : Parameter) {
        this.acceptAll(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitOperation(io.apicurio.datamodels.core.models.common.Operation)
     * @param {Operation} node
     */
    public visitOperation(node : Operation) {
        this.acceptAll(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitSecurityScheme(io.apicurio.datamodels.core.models.common.SecurityScheme)
     * @param {SecurityScheme} node
     */
    public visitSecurityScheme(node : SecurityScheme) {
        this.acceptAll(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitSchemaDefinition(io.apicurio.datamodels.core.models.common.IDefinition)
     * @param {*} node
     */
    public visitSchemaDefinition(node : IDefinition) {
        this.acceptAll(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitParameterDefinition(io.apicurio.datamodels.core.models.common.IDefinition)
     * @param {*} node
     */
    public visitParameterDefinition(node : IDefinition) {
        this.acceptAll(node);
    }
}
CompositeVisitor["__class"] = "io.apicurio.datamodels.core.visitors.CompositeVisitor";
CompositeVisitor["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor"];




